<template>
    <div>
        <mobile-naigation />
    
        <v-flex-container center>
            <v-card-container>
                <v-card>
                    <div
                        v-if="registeredEmail"
                        v-padding.xs.top="3"
                        v-padding.xs.bottom="1"
                        v-padding.md.left="7"
                        v-padding.md.right="7"
                        v-padding.xs.left="2"
                        v-padding.xs.right="2"
                        v-text-align.center
                    >
                        <v-text>
                            На адрес <strong>{{ registeredEmail }}</strong>
                            высланы инструкции по подверждению регистрации
                            и входу в ваш личный кабинет
                        </v-text>
                    </div>
                    <div v-padding.xs.top="registeredEmail ? 0 : 3" v-padding.md.left="8" v-padding.md.right="8" v-padding.xs.left="2" v-padding.xs.right="2">
                        <v-form :validate="validateForm" @submit="handleSubmit">
                            <template scope="api">
                                <v-form-input field="username" :readonly="isLogging" label="Email" type="email" v-margin.bottom="2" />
                                <v-form-input field="password" :readonly="isLogging" label="Пароль" type="password" />
    
                                <div v-padding.top="4">
                                    <v-spinner block :active="isLogging">
                                        <v-button-green :disabled="api.isInvalid || isLogging" type="submit" primary block>
                                            войти
                                        </v-button-green>
                                    </v-spinner>
    
                                    <div v-if="serverError" v-padding.top="1">
                                        <v-text danger>
                                            {{ serverError }}
                                        </v-text>
                                    </div>
                                </div>
                            </template>
                        </v-form>
    
                        <div v-text-align.center v-padding.top="4" v-padding.bottom="4">
                            <v-router-link size="subheadling" :to="{ name: 'recovery' }">
                                Забыли пароль?
                            </v-router-link>
                        </div>
                    </div>
                </v-card>
            </v-card-container>
        </v-flex-container>
    
        <v-flex-container center>
            <v-card-container>
                <!-- <div v-text-align.center v-padding.top="3" v-padding.bottom="9">
                    <v-text>
                        Еще не зарегистрировались?
    
                        <v-router-link :to="{ name: 'register' }">
                            Зарегистрируйтесь
                        </v-router-link>
                    </v-text>
                </div> -->
            </v-card-container>
        </v-flex-container>

        <v-modal :active="demoAccessed" @close="onCloseSuccessModal">
            <div v-padding="3">
                <v-text type="headline">Спасибо!</v-text>

                <div v-margin.top="3">
                    <v-text type="subheadling">
                        Менеджер свяжется с вами до 18:00 по&nbsp;МСК и&nbsp;откроет демо-доступ.
                        Дождитесь его звонка или <v-router-link :to="{ name: 'register' }">зарегистрируйтесь</v-router-link>,
                        чтобы получить доступ ко&nbsp;всем инструментам проверки уже сейчас.
                    </v-text>
                </div>

                <div v-margin.top="2" v-text-align.right>
                    <v-button flat primary @click="onCloseSuccessModal">закрыть</v-button>
                </div>
            </div>
        </v-modal>
    </div>
</template>
<script>
    import MobileNaigation from '../MobileNaigation';
    import {
        vCard,
        vCardContainer,
        vFlexContainer,
        vButton as vButtonGreen,
    } from '../baseComponents';

    import { validate, isRequired, isEmail } from '../../../services/validator';

    const loginRules = {
        password: [
            (val) => isRequired(val, 'Введите пароль'),
        ],
        username: [
            (val) => isRequired(val, 'Введите email'),
            isEmail,
        ],
    };

    export default {
        name: 'login',
        props: {
            demoAccessed: Boolean,
            registeredEmail: String,
            onLogin: Function,
            onCloseSuccessModal: Function,
        },
        components: {
            vCard,
            vCardContainer,
            vFlexContainer,
            vButtonGreen,
            MobileNaigation,
        },
        data() {
            return {
                isLogging: false,
                serverError: undefined,
            }
        },
        methods: {
            validateForm(values) {
                return validate(values, loginRules);
            },
            handleSubmit(values) {
                if (this.isLogging) {
                    return;
                }

                this.isLogging = true;
                this.serverError = undefined;

                this.onLogin(values)
                    .then(() => {
                        this.isLogging = false;
                    })
                    .catch((res) => {
                        this.isLogging = false;
                        this.serverError = res.message;
                    });
            },
        }
    }
</script>



// WEBPACK FOOTER //
// Login.vue?61a38238